/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Divider from './components/Divider';
import StyledAuthView, {
  Subtitle,
  Title,
  FormContent,
  SubmitButtonContainer,
  ErrorMessage,
  ForgotPasswordLink,
  SignInText,
  SignUpText,
} from './styles';
import { Texter, Modal } from 'kinedu-react-components';
import TexterBasic from 'views/AuthView/styles/themes/TexterBasic';
import Button from './Button';
import { useRouter } from 'routes';
import { APP_SECTIONS_PATHS } from 'constants/routes';
import ForgotPasswordView from './components/ForgotPasswordView';
import EmailSentView from './components/EmailSentView';
import GoogleButton from './components/GoogleButton';
import useAuth from './hooks/useAuth';
import { Formik } from 'formik';
import * as Yup from 'yup';
import RendererIf from 'components/RendererIf';

interface IAuthComponentProps {
  isLogin?: boolean;
  onForgotPassword?: Function;
  isSignUpVersion?: boolean;
  onClickSignUp?: Function;
  onClickSignIn?: Function;
  email?: string;
}

const AuthComponent: React.FC<IAuthComponentProps> = ({
  isLogin = true,
  onForgotPassword,
  isSignUpVersion,
  onClickSignUp,
  onClickSignIn,
}) => {
  localStorage.setItem('GOOGLE_AUTH_ENABLED', 'true');
  const showGoogleAuth = localStorage.getItem('SHOW_GOOGLE_AUTH') === 'true';
  const { t } = useTranslation();
  const { history } = useRouter();

  const [formikRef, setFormikRef] = useState<any>({});

  const [isForgotPassModalOpen, setIsForgotPassModalOpen] = useState<boolean>(
    false,
  );
  const [emailSent, setEmailSent] = useState<any>('');
  const [isBusy, setIsBusy] = useState(false);

  const { onLogin, onSignup, errors: errorsAuth } = useAuth();

  const initialValues = {
    email: '',
    password: '',
  };

  const FormValidationSchemaRules: any = {
    email: Yup.string()
      .required(t('validations:FIELD_REQUIRED'))
      .email(t('auth:ERRORS.INVALID_EMAIL')),
    password: Yup.string().required(t('auth:ERRORS.PASSWORD_REQUIRED')),
  };

  if (!isLogin) {
    FormValidationSchemaRules.password_confirmation = Yup.string()
      .oneOf(
        [Yup.ref('password'), null],
        t('auth:ERRORS.PASSWORD_CONFIRMATION'),
      )
      .required(t('auth:ERRORS.PASSWORD_REQUIRED'));
  }

  const FormValidationSchema = Yup.object().shape(FormValidationSchemaRules);

  const handleOnSubmitForm = (values: any) => {
    console.info('handleOnSubmitForm', values);
    setIsBusy(true);

    if (!isLogin) {
      onSignup(values).finally(() => {
        setIsBusy(false);
      });
    } else {
      onLogin(values).finally(() => {
        setIsBusy(false);
      });
    }

    // event.preventDefault();

    // const errorsList = {
    //   ...errors,
    //   emailError: data.email === '' ? t('ERRORS.EMAIL_REQUIRED') : '',
    //   passError: data.password === '' ? t('ERRORS.PASSWORD_REQUIRED') : '',
    // };

    // console.info('errorsList', errorsList)
  };

  const handleOnForgotPassword = () => {
    console.info('handleOnForgotPassword');

    setIsForgotPassModalOpen(true);

    if (onForgotPassword) {
      onForgotPassword();
    }
  };

  const handleClickToogleSing = (goToLogin: boolean = false) => {
    history.push(
      goToLogin ? APP_SECTIONS_PATHS.SIGNIN : APP_SECTIONS_PATHS.SIGNUP,
    );
  };

  const isSignUp = useMemo(() => !isLogin, [isLogin]);

  useEffect(() => {
    // console.info('formikRef', formikRef);
    if (formikRef) {
      // eslint-disable-next-line no-unused-expressions
      // console.info(formikRef.getFormikContext?.().values)
      // formikRef?.getFormikContext()?.values;
    }
    // if (
    //   formikRef?.validateForm &&
    //   general_info?.name && general_info?.lastname && general_info?.email
    // )
    //   formikRef?.validateForm(general_info).then((res: any) => {
    //     setInitialValuesValid(Object.keys(res).length === 0);
    //   });
  }, [formikRef]);

  return (
    <StyledAuthView>
      <Title>
        {isSignUp
          ? t('auth:AUTH_VIEW.CREATE_ACCOUNT')
          : t('auth:AUTH_VIEW.WELCOME_BACK')}
      </Title>
      <Subtitle>
        {isSignUp
          ? t('auth:AUTH_VIEW.REGISTER_TO_START')
          : t('auth:AUTH_VIEW.EXISTING_ACCOUNT')}
      </Subtitle>
      <RendererIf condition={!isSignUp}>
        <>
          <GoogleButton
            text={
              isSignUp
                ? t('auth:SIGNUP_WITH_GOOGLE')
                : t('auth:LOGIN_WITH_GOOGLE')
            }
          />
          <Divider text={t('auth:OR')} />
        </>
      </RendererIf>

      <Formik
        ref={(ref) => setFormikRef(ref)}
        initialValues={initialValues}
        validationSchema={FormValidationSchema}
        onSubmit={handleOnSubmitForm}
        validateOnBlur
        validateOnChange
        // onchange={(values) => console.info('veee', values)}
        render={({ setFieldValue, values, errors, isValid }: any) => (
          <FormContent>
            <Texter
              type="email"
              value={values.email}
              required
              theme={TexterBasic}
              label={t('auth:EMAIL')}
              onChange={(event: any) => {
                setFieldValue('email', event);
              }}
            />
            {errors?.email && <ErrorMessage>{t(errors.email)}</ErrorMessage>}
            {errorsAuth?.emailError && (
              <ErrorMessage>{t(errorsAuth.emailError)}</ErrorMessage>
            )}

            <Texter
              required
              type="password"
              theme={TexterBasic}
              label={t('auth:PASSWORD')}
              onChange={(event: any) => {
                setFieldValue('password', event);
              }}
            />

            {errors?.password && (
              <ErrorMessage>{t(errors.password)}</ErrorMessage>
            )}

            {errorsAuth?.generalError && (
              <ErrorMessage>{t(errorsAuth.generalError)}</ErrorMessage>
            )}

            {isSignUp && (
              <>
                <Texter
                  type="password"
                  required
                  theme={TexterBasic}
                  label={t('auth:PASSWORD_CONFIRMATION')}
                  onChange={(event: any) => {
                    setFieldValue('password_confirmation', event);
                  }}
                />
                <ErrorMessage>
                  {t(
                    errors.password_confirmation ||
                      errors.password_confirmation,
                  )}
                </ErrorMessage>
              </>
            )}

            {isLogin && (
              <ForgotPasswordLink onClick={handleOnForgotPassword}>
                {t('auth:AUTH_VIEW.FORGOT_PASSWORD')}
              </ForgotPasswordLink>
            )}

            <SubmitButtonContainer>
              <Button
                dense
                color="primary"
                shadowColored
                fill
                type="submit"
                disabled={!isValid || isBusy}
              >
                {isSignUp ? t('auth:SIGNUP') : t('auth:LOGIN')}
              </Button>
            </SubmitButtonContainer>
          </FormContent>
        )}
      />

      {isSignUp ? (
        <SignInText>
          {t('auth:AUTH_VIEW.ALREADY_HAVE_ACCOUNT')}
          <span onClick={() => handleClickToogleSing(true)}>
            {t('auth:LOGIN')}
          </span>
        </SignInText>
      ) : (
        <SignUpText>
          {t('auth:AUTH_VIEW.DONT_HAVE_ACCOUNT_YET')}
          <span onClick={() => handleClickToogleSing()}>
            {t('auth:SIGNUP')}
          </span>
        </SignUpText>
      )}

      <Modal
        openModal={isForgotPassModalOpen}
        onClosedModal={() => {
          setIsForgotPassModalOpen(false);
          setEmailSent('');
        }}
      >
        {() =>
          emailSent ? (
            <EmailSentView email={emailSent} />
          ) : (
            <ForgotPasswordView
              onSuccess={(mail: string) => setEmailSent(mail)}
            />
          )
        }
      </Modal>
    </StyledAuthView>
  );
};

export default AuthComponent;
